import { Component, OnInit } from '@angular/core';
import { AuthErrors } from '../shared/enums/auth-errors';
import { Router } from '@angular/router';

@Component({
  selector: 'app-force-log-out',
  template: '<span></span>',
})
export class ForceLogOutComponent implements OnInit {
  constructor(private readonly router: Router) {}

  ngOnInit() {
    this.router.navigate([`auth-error`], { queryParams: { error: AuthErrors.ForceLogout } });
  }
}
